// extracted by mini-css-extract-plugin
export var box = "_8w-1";
export var checked = "_8w-2";
export var descriptionSpacer = "_8w-9";
export var disabled = "_8w-3";
export var icon = "_8w-6";
export var input = "_8w-0";
export var labelSpacer = "_8w-8";
export var medium = "_8w-5";
export var small = "_8w-4";
export var text = "_8w-7";